export enum RulesEngineRuleCustomerTypeEnum
{
    All = 0,
    Energy = 1,
    Water = 2
}
